<sd-modal>
  <div class="wrapper">
    <h4>Адрес доставки</h4>
    <div class="text-help">Выберите адрес из подсказок с точностью до дома или укажите на карте</div>
    <sd-delivery-address-dialog></sd-delivery-address-dialog>
  </div>
</sd-modal>
